'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElementFinder = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ScopeChecker = require('./ScopeChecker');

var _util = require('./util');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function toElementArray(nodeList) {
  var length = nodeList.length;
  var arr = Array(length);

  for (var i = 0; i < length; ++i) {
    arr[i] = nodeList[i];
  }

  return arr;
}

var ElementFinder = exports.ElementFinder = function () {
  function ElementFinder(namespace, isolateModule) {
    _classCallCheck(this, ElementFinder);

    this.namespace = namespace;
    this.isolateModule = isolateModule;
  }

  _createClass(ElementFinder, [{
    key: 'call',
    value: function call(rootElement) {
      // eslint-disable-line complexity
      var namespace = this.namespace;
      if (namespace.join('') === '') {
        return rootElement;
      }

      var scope = (0, _util.getScope)(namespace);
      var selector = (0, _util.getSelectors)(namespace);
      var scopeChecker = new _ScopeChecker.ScopeChecker(scope, this.isolateModule);

      var topNode = rootElement;
      var topNodeMatches = [];

      if (scope.length > 0) {
        topNode = this.isolateModule.getIsolatedElement(scope) || rootElement;
        if (selector && (0, _util.matchesSelector)(topNode, selector)) {
          topNodeMatches[0] = topNode;
        }
      }

      return toElementArray(topNode.querySelectorAll(selector)).filter(scopeChecker.isStrictlyInRootScope, scopeChecker).concat(topNodeMatches);
    }
  }]);

  return ElementFinder;
}();


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/ElementFinder.js
 **/